
import Emulator from "@/components/Emulator.vue";
import Testing from "@/components/Testing.vue";
import { Constants } from "@/constant/Constants";
import AbstractVue from "@/views/AbstractVue";
import { Options } from "vue-class-component";
import { localStorageGetOrDefault, localStorageSet } from '@/data/Utils';

@Options({
  components: {
    Emulator,
    Testing,
  },
  watch: {
    forceDevice: function () {
      this.updateGameUrl();
    },
    portrait: function () {
      this.updateGameUrl();
    },
    turbo: function () {
      this.updateGameUrl();
    },
    netPosition: function () {
      this.updateGameUrl();
    },
    localise: function () {
      this.updateGameUrl();
    },
    testDisplay: function () {
      this.updateGameUrl();
    },
    autoplay: function () {
      this.updateGameUrl();
    },
    forceDemo: function () {
      this.updateGameUrl();
    },
    forceCustomError: function () {
      this.updateGameUrl();
    },
    forceBalance: function () {
      this.parameters.resetPlayerId();
    },
    showTheoreticalRTP: function () {
      this.updateGameUrl();
    },
    homeButtonEnabled: function () {
      this.updateGameUrl();
    },
    depositEnabled: function () {
      this.updateGameUrl();
    },
    buyBonusEnabled: function () {
      this.updateGameUrl();
    },
    historyEnabled: function () {
      this.updateGameUrl();
    },
  },
})
export default class GameSelect extends AbstractVue {
  onLockBarChange() {
    this.lockBar = !this.lockBar;
    localStorageSet("is_locked", this.lockBar);
  }
  showBar = true;
  lockBar = false;
  showUI = true;
  gameUrl: string = null;
  frameKey = false;
  popupMessage = "";
  popup = false;
  popupError = false;
  showEmulator = false;

  refreshGame(): void {
    this.frameKey = !this.frameKey;
    console.clear();
  }

  created(): void {
    if (this.parameters.game == null) {
      this.$router.push("/");
    } else {
      this.parameters.currency = localStorageGetOrDefault("player_currency", this.parameters.game.defaultCurrency ?? this.parameters.currency);
      if (this.parameters.game.defaultParams) {
        this.parameters.queryParams = this.parameters.game.defaultParams;
      }
      this.updateGameUrl();
      this.$watch("launchAddress", function (this: GameSelect) {
        this.updateGameUrl();
      });
      this.$watch("queryParams", function (this: GameSelect) {
        this.updateGameUrl();
      });
      window.addEventListener("keydown", (e) => {
        if (e.key == "r") {
          this.refreshGame();
        }
      });
      window.addEventListener('keyup', event => {
        if (event.key === 'Escape') {
          this.changeUI()
        }
      })
    }
    this.lockBar = localStorageGetOrDefault("is_locked", false);
  }

  sendSuccess(): void {
    this.showPopup("Outcome successfully set", true);
  }

  launchEmulator(): void {
    this.showEmulator = true;
  }

  closeEmulator(): void {
    this.showEmulator = false;
  }

  changeUI(): void {
    this.showUI = !this.showUI;
  }

  popout(): void {
    window.open(this.gameUrl, "game");
  }

  failedToUpdateBalance(): void {
    this.showPopup("Failed to update balance", false);
  }

  sendFail(): void {
    this.showPopup("Outcome could not be set", false);
  }

  clearSuccess(): void {
    this.showPopup("Outcome successfully cleared", true);
  }

  clearFail(): void {
    this.showPopup("Outcome could not be cleared", false);
  }

  freeRoundsSuccess(): void {
    this.showPopup("Free Rounds Success", true);
  }

  freeRoundsFail(): void {
    this.showPopup("Free Rounds Failed", false);
  }

  autoCompleteSuccess(): void {
    this.showPopup("Auto Complete Success", true);
  }

  autoCompleteFail(): void {
    this.showPopup("Auto Complete Failed", false);
  }

  showPopup(message: string, success: boolean): void {
    this.popupMessage = message;
    this.popupError = !success;
    this.popup = true;
    setTimeout(() => (this.popup = false), 3000);
  }

  updateGameUrl(): void {
    console.log("Launch Address: ");
    console.log(this.launchAddress);

    this.axios
      .get(this.launchAddress)
      .then((response) => {
        console.log("RESPONSE:");
        console.log(response.data);
        if (
          this.isLocal &&
          this.parameters.environment.serverAddress.includes("octopusrgs")
        ) {
          this.parameters.krakenPlayerId = this.getPlayerId(
            response.data.gameUrl
          );
          this.parameters.localToken = response.data.token;
          let gameUrl: string = response.data.gameUrl;
          let params: string = gameUrl.split("?")[1];
          // params += "&testConfig=local";
          this.gameUrl = this.processUrl(
            this.parameters.prototypeUrl + "?" + params
          );
          this.refreshGame();
          console.group("Local (octopusrgs):");
          console.log(this.gameUrl);
          console.groupEnd();
        } else if (this.isLocal) {
          this.parameters.localToken = response.data.token;
          this.parameters.krakenPlayerId = this.getPlayerId(
            response.data.gameUrl
          );
          this.gameUrl = this.processUrl(this.parameters.localUrl);
          console.group("Local: ");
          console.log(this.parameters.localToken);
          console.log(this.parameters.krakenPlayerId);
          console.log(this.localUrl);
          console.log(this.gameUrl);
          console.groupEnd();

          this.refreshGame();
        } else if (this.isMock && !this.parameters.environment.serverAddress.includes("octopusrgs")) {
          this.parameters.localToken = response.data.token;
          this.parameters.krakenPlayerId = this.getPlayerId(
            response.data.gameUrl
          );
          const params = new URLSearchParams(
            this.parameters.localParameters
          ).toString();
          const mockURL = new URL(this.clientAddress);
          const clientPath = !this.clientAddress.includes("localhost") && this.clientPath || "";
          mockURL.pathname = mockURL.pathname + clientPath;
          mockURL.search = params;
          this.gameUrl = this.processUrl(mockURL.toString());
          console.group("Mock: ");
          console.log(this.parameters.localToken);
          console.log(this.parameters.krakenPlayerId);
          console.log(this.clientAddress);
          console.log(this.gameUrl);
          console.groupEnd();

          this.refreshGame();
        } else {
          this.parameters.krakenPlayerId = this.getPlayerId(
            response.data.gameUrl
          );
          console.group("DEFAULT LAUNCH:");
          console.log(response.data.gameUrl);
          console.groupEnd();
          this.gameUrl = this.processUrl(response.data.gameUrl);

          this.refreshGame();
          if (this.gameUrl.includes("null")) {
            this.showPopup(
              "Launch Address contains null - check game provider on kraken",
              false
            );
          }
        }
        console.log("IFrame game URL: ");
        console.log(this.gameUrl);
      })
      .catch((err) => {
        console.log(err);
        this.showPopup("Unable to reach server", false);
        console.log("Attempting URL: " + this.launchAddress);
      });
  }

  processUrl(url: string): string {
    url += "&serverPath=" + this.parameters.game.serverPath;
    url += "&hideTurbo=" + !this.turbo;
    url += "&showNetPosition=" + this.netPosition;
    url += "&hideAutoplay=" + !this.autoplay;
    url += "&homeButtonEnabled=" + this.homeButtonEnabled;
    url += "&depositEnabled=" + this.depositEnabled;
    url += "&historyEnabled=" + this.historyEnabled;
    url += "&showTheoreticalRTP=" + this.showTheoreticalRTP; // we dont have this
    url += "&buyBonusEnabled=" + this.buyBonusEnabled; // we dont have this
    url += "&operatorBrandId=" + this.parameters.integration.brand ?? "test-brand";
    url += "&emulator=true";

    if (this.queryParams !== null) {
      url += this.queryParams;
    }
    if (this.forceDemo) {
      url += "&forceDemo=" + this.forceDemo;
      url += "&playMode=" + "DEMO";
    } else {
      url += "&playMode=" + this.parameters.playMode;
    }
    return url;
  }

  getPlayerId(gameUrl: string): string {
    let params = gameUrl.split("?")[1];
    let value: string;
    if (params) {
      params = params.replace(/#[^?]+/, "");
      let urlVariables = params.split("&");
      for (let i = 0; i < urlVariables.length; i++) {
        let parameter = urlVariables[i].split("=");
        let parameterName = parameter[0];
        if (parameterName === Constants.PLAYER_ID) {
          value = decodeURIComponent(parameter[1].replace(/\+/g, "%20"));
        }
      }
    }
    return value;
  }

  get prototypeAddress(): string {
    return (
      "https://s3.eu-west-2.amazonaws.com/playrogue.com/hidden/games/" +
      this.parameters.game.id +
      "/index.html?"
    );
  }

  get clientAddress(): string {
    return this.parameters.environment.clientAddress;
  }

  get clientPath(): string | undefined {
    const { id, version, buildPrefix } = this.parameters.game;
    return version ? `${buildPrefix}-${id}/${version}/package/output/index.html` : undefined;
  }

  home(): void {
    this.parameters.reset();
    this.store.state.prototype = false;
    this.parameters.environment = this.store.state.environments[0];
    this.$router.push("/");
  }

  get sideBarIcon(): string {
    return this.showBar ? "arrow-left" : "arrow-right";
  }

  get lockBarIcon(): string {
    return this.lockBar ? "lock" : "lock-open";
  }

  get launchAddress(): string {
    return this.parameters.launchAddress;
  }

  get localUrl(): string {
    return this.parameters.localUrl;
  }

  get queryParams(): string {
    return this.parameters.queryParams;
  }

  get autoplay(): boolean {
    return this.parameters.autoplay;
  }

  get turbo(): boolean {
    return this.parameters.turbo;
  }

  get netPosition(): boolean {
    return this.parameters.netPosition;
  }

  get forceDemo(): boolean {
    return this.parameters.forceDemo;
  }

  get forceCustomError(): boolean {
    return this.parameters.forceCustomError;
  }

  get forceBalance(): boolean {
    return this.parameters.forceBalance;
  }

  get showTheoreticalRTP(): boolean {
    return this.parameters.showTheoreticalRTP;
  }

  get homeButtonEnabled(): boolean {
    return this.parameters.homeButtonEnabled;
  }

  get depositEnabled(): boolean {
    return this.parameters.depositEnabled;
  }

  get buyBonusEnabled(): boolean {
    return this.parameters.buyBonusEnabled;
  }

  get historyEnabled(): boolean {
    return this.parameters.historyEnabled;
  }
}
